const Flash = () => {
  return (
    <svg
      className='list-options__svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M11.4929 2.30545C10.5097 1.74143 9.37014 1.41895 8.1553 1.41895C4.4453 1.41895 1.43774 4.4265 1.43774 8.1365C1.43774 10.3879 2.54528 12.3806 4.24524 13.5995L2.32104 16L4.81932 13.9685C5.80221 14.5319 6.94114 14.8541 8.1553 14.8541C11.8653 14.8541 14.8729 11.8465 14.8729 8.1365C14.8729 5.91869 13.7981 3.95189 12.141 2.72856L14.3281 0L11.4929 2.30545ZM10.6503 2.99062L5.47783 7.19671H7.67872L4.14365 10.8796H6.42539L4.87179 12.8178C3.39976 11.7834 2.43774 10.0723 2.43774 8.1365C2.43774 4.97878 4.99758 2.41895 8.1553 2.41895C9.04983 2.41895 9.89638 2.62437 10.6503 2.99062ZM11.5149 3.50961L10.1108 5.26127H12.3926L9.08752 8.80329H11.1713L5.66202 13.2832C6.41554 13.649 7.26147 13.8541 8.1553 13.8541C11.313 13.8541 13.8729 11.2942 13.8729 8.1365C13.8729 6.23427 12.9439 4.549 11.5149 3.50961Z'
        fill='white'
      />
    </svg>
  );
};
export default Flash;
